<template>
  <div>...</div>
</template>

<script>
export default {
  created() {
    this.logout();
  },
  methods: {
    async logout() {
      const headers = this.getHeaders();
      this.$store.commit("setAlert", false);
      this.$sessionStore.commit("clearMapState");
      this.$sessionStore.commit("clearSearchState");
      try {
        if (this.tokenNeedsRefresh()) await this.refreshToken();
        await this.$http.post("/v1/logout", {}, headers);
      } catch (err) {
        console.log({ err });
        localStorage.setItem("accessToken", "");
        localStorage.setItem("refreshToken", "");
        localStorage.removeItem("vuex");
        this.$sessionStore.commit("setSearchDefault");
        this.$sessionStore.commit("setStudyDefault");
        this.$router.push("/login");
      }

      localStorage.setItem("accessToken", "");
      localStorage.setItem("refreshToken", "");
      localStorage.removeItem("_c", "");
      localStorage.removeItem("_cs", "");
      localStorage.removeItem("_p", "");
      localStorage.removeItem("_ud", "");
      localStorage.removeItem("vuex");
      console.log("Logged out, redirecting to login page");
      this.$sessionStore.commit("setSearchDefault");
      this.$sessionStore.commit("setStudyDefault");
      this.$router.push("/login");
    },
  }
};
</script>